// =====================================================================================
// 商品タイトルの「｜」を <br> に変換（商品ページ＋コレクショングリッド）
// =====================================================================================
(function () {

  // -- 内部 helper: 指定セレクタ群に対して「｜」→ <br> を適用 --
  function applyMultiLineTitlesInRoot(root) {
    root = root || document;
    if (!root.querySelectorAll) return;

    // 対象となる「タイトルのラッパ」セレクタ
    var SELECTORS = [
      '.product-details-product-title', // 商品ページの h1
      '.product-card-basic__title',     // Flow の product-card-basic
      '.product-grid--title'            // コレクショングリッド（今回の HTML）
    ];

    SELECTORS.forEach(function (selector) {
      var wrappers = root.querySelectorAll(selector);
      if (!wrappers.length) return;

      wrappers.forEach(function (wrapper) {
        // aタグ内にタイトルが入っている場合を優先
        var target = wrapper.querySelector('a') || wrapper;
        if (!target) return;

        var text = (target.textContent || '').trim();
        if (!text || text.indexOf('｜') === -1) return; // 全角「｜」が無ければ何もしない

        // Flow の 1行省略クラスが付いていると改行が効きにくいので外す
        try {
          target.classList.remove('text-truncate--line');
        } catch (e) {}

        // 「｜」で分割 → 前後のスペースを除去 → 空文字は捨てる
        var parts = text
          .split('｜')
          .map(function (part) { return part.trim(); })
          .filter(function (part) { return part.length > 0; });

        if (!parts.length) return;

        // <br> で結合して表示
        target.innerHTML = parts.join('<br>');
      });
    });
  }

  // -- 初期実行 --
  function runAll() {
    try {
      applyMultiLineTitlesInRoot(document);
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('applyMultiLineTitles failed', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () { runAll(); },
      { once: true }
    );
  } else {
    runAll();
  }

  // -- 後から追加される要素（AJAX, ドロワーなど）にも対応 --
  var mo = new MutationObserver(function (mutations) {
    var need = false;

    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          (node.matches && node.matches('.product-details-product-title, .product-card-basic__title, .product-grid--title')) ||
          (node.querySelector && node.querySelector('.product-details-product-title, .product-card-basic__title, .product-grid--title'))
        ) {
          need = true;
        }
      });
    });

    if (need) {
      runAll();
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
